// Mã lỗi chuẩn google.rpc.Code — gRPC-Gateway đặt ở field `code` của body lỗi.
export const GRPC_CODE = {
  OK: 0,
  CANCELLED: 1,
  UNKNOWN: 2,
  INVALID_ARGUMENT: 3,
  DEADLINE_EXCEEDED: 4,
  NOT_FOUND: 5,
  ALREADY_EXISTS: 6,
  PERMISSION_DENIED: 7,
  RESOURCE_EXHAUSTED: 8,
  FAILED_PRECONDITION: 9,
  ABORTED: 10,
  OUT_OF_RANGE: 11,
  UNIMPLEMENTED: 12,
  INTERNAL: 13,
  UNAVAILABLE: 14,
  DATA_LOSS: 15,
  UNAUTHENTICATED: 16,
};

export const parseGrpcStatus = (body) => {
  if (!body || typeof body !== 'object' || typeof body.code !== 'number') {
    return { grpcCode: null, message: null, details: [] };
  }
  return {
    grpcCode: body.code,
    message: typeof body.message === 'string' ? body.message : null,
    details: Array.isArray(body.details) ? body.details : [],
  };
};

// BE trả CẢ lỗi nhập sai lẫn lỗi nghiệp vụ (không tìm thấy) bằng INVALID_ARGUMENT, nên riêng mã lỗi
// không phân biệt được. Dấu hiệu duy nhất đáng tin: lỗi do validate luôn kèm `metadata.error_name`
// đuôi `ValidationError` (protoc-gen-validate sinh ra). KHÔNG so chuỗi `message` vì BE localize được.
export const isValidationError = (error) =>
  (error?.details || []).some((detail) => /ValidationError$/.test(detail?.metadata?.error_name || ''));
